// Casa Vino — shared constants
// WhatsApp link generation for orders & reservations.

export const BRAND = {
  name: "Casa Vino",
  tagline: "Vino artisanale di Puglia",
  phoneDisplay: "+32 486 45 89 89",
  phoneIntl: "32486458989", // E.164 minus the +
  email: "mendolaangelo@hotmail.com",
  address: "Brusselbaan 418, 1600 Sint-Pieters-Leeuw",
  city: "Bruxelles & alentours",
};

export const buildWhatsAppOrderLink = (items, subtotal) => {
  const lines = items.map(
    (i) => `• ${i.qty} × ${i.name} — ${(i.qty * i.price).toFixed(2)}€`
  );
  const text = [
    `Buongiorno Casa Vino !`,
    ``,
    `Je souhaite passer commande :`,
    ...lines,
    ``,
    `Total estimé : ${subtotal.toFixed(2)}€`,
    `Paiement : cash à la livraison.`,
    ``,
    `Mes coordonnées :`,
    `Nom : `,
    `Adresse : `,
    `Téléphone : `,
    ``,
    `Grazie mille !`,
  ].join("\n");
  return `https://wa.me/${BRAND.phoneIntl}?text=${encodeURIComponent(text)}`;
};

export const buildWhatsAppReservationLink = ({ name, date, time, guests, message }) => {
  const text = [
    `Buongiorno Casa Vino !`,
    ``,
    `Je souhaite réserver une dégustation :`,
    `Nom : ${name}`,
    `Date : ${date}`,
    `Heure : ${time}`,
    `Personnes : ${guests}`,
    message ? `Message : ${message}` : ``,
    ``,
    `Grazie mille !`,
  ].filter(Boolean).join("\n");
  return `https://wa.me/${BRAND.phoneIntl}?text=${encodeURIComponent(text)}`;
};

export const buildWhatsAppSimpleLink = (msg = "Buongiorno Casa Vino !") =>
  `https://wa.me/${BRAND.phoneIntl}?text=${encodeURIComponent(msg)}`;
